import { LOAD_CITIZEN_INFO, STORE_CITIZEN_INFO } from "src/actions/types";

const initialState = {
  citizen: null,
  show: false,
  loadCitizenInfo: false,
};

const searchReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case STORE_CITIZEN_INFO:
      return {
        ...state,
        ...actions.payload,
        // citizen: actions.payload,
        // loadCitizenInfo: false,
        // show: true,
      };
    case LOAD_CITIZEN_INFO:
      return {
        ...state,
        loadCitizenInfo: true,
      };
    default:
      return state;
  }
};

export default searchReducer;
